













import { computed, defineComponent } from "@vue/composition-api";
import { countryList } from "@/lib/countryList";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { ofacCountries } from "./ofacCountriesList";
import usStatesList from "./us-states";

export default defineComponent({
  name: "BillingDetailsForm",
  components: { BaseForm },
  model: { prop: "values" },
  props: { values: { type: Object as () => FormValues, required: true } },
  setup(props, { emit }) {
    const fields = computed<FormFields>(() => [
      {
        name: "country",
        label: $t("Country"),
        type: "select",
        options: countryList
          .filter(i => ofacCountries.indexOf(i.name) === -1)
          .map(i => ({ value: i.code, text: $t(i.name) })),
      },
      {
        name: "address",
        label: $t("Address"),
        rules: ["required"],
      },
      {
        name: "city",
        label: $t("City"),
        rules: ["required"],
      },
      {
        name: "state",
        label: $t("State"),
        options: [
          { value: undefined, text: $t("Select state"), disabled: true },
          ...usStatesList.map(i => ({ value: i.stusab, text: i.state_name })),
        ],
        type: props.values["country"] === "US" ? "select" : undefined,
        rules: ["required"],
      },
      {
        name: "zip",
        label: $t("Zip code"),
        rules: ["required"],
      },
    ]);
    const onInput = (v: FormValues) => {
      if ([props.values["country"], v["country"]].some(i => i === "US") && props.values["country"] !== v["country"]) {
        emit("input", {
          ...v,
          state: undefined,
        });
      } else {
        emit("input", v);
      }
    };

    return {
      fields,
      onInput,
    };
  },
});
